import axios from "axios";
import { store } from "../../store";
import { logoutUser } from "../../store/actions/auth";
import { showWarningAlert } from "../../store/actions/alerts";
import { /*BASE_URL,*/ HTTP_REQUEST_TIMEOUT } from "../../config";
import { getAccessToken } from "../storage";

export default class {
  constructor(type = "private") {
    this.loading = false;
    this.cancelToken = null;

    this.axiosInstance = axios.create({
      //baseURL: BASE_URL,
      timeout: HTTP_REQUEST_TIMEOUT
    });

    this.axiosInstance.interceptors.request.use(
      request => {
        if (type.toLowerCase() !== "public") {
          //console.log("Private Interceptor Request");
          //const accessToken = store.getState().auth.accessToken;

          //get access token from local storage
          let accessToken = getAccessToken();

          // *** GETTING FROM REDUX WILL CREATE ISSUE IN MULTIPLE TABS AFTER LOGOUT ***
          //get access token from redux store if it's not available at local storage
          // if (accessToken === null) {
          //   accessToken = store.getState().auth.accessToken;
          // }

          if (accessToken !== null) {
            request.headers["x-access-token"] = accessToken;
            return request;
          } else {
            store.dispatch(showWarningAlert("No Token. Session Terminated!"));
            store.dispatch(logoutUser());
            return {
              ...request,
              cancelToken: new axios.CancelToken(cancel =>
                cancel("Access Token Expired!!")
              )
            };
          }
        } else {
          //console.log("Public Interceptor Request");
          return request;
        }
      },
      error => {
        return Promise.reject(error);
      }
    );

    this.axiosInstance.interceptors.response.use(
      response => {
        //console.log("Interceptor Response");
        return response;
      },
      error => {
        if (!!error.response && error.response.status === 401) {
          //console.log("401 error - logging out");
          store.dispatch(logoutUser());
          store.dispatch(showWarningAlert("401 - Session Expired!"));
        }
        return Promise.reject(error);
      }
    );
  }

  request({ url, method, params, data }) {
    this.loading = true;
    return new Promise((resolve, reject) => {
      this.axiosInstance({
        url,
        method,
        params,
        data,
        cancelToken: new axios.CancelToken(token => {
          this.cancelToken = token;
        })
      })
        .then(response => {
          this.cancelToken = null;
          this.loading = false;
          //console.log(response);
          resolve(response);
        })
        .catch(error => {
          this.loading = false;
          this.cancelToken = null;
          // Early return if request was cancelled
          if (axios.isCancel(error)) {
            //console.log("Axios Cancelled - ", error.message);
            return;
          }
          //console.error(error);
          reject(error);
        });
    });
  }

  cancel(msg) {
    if (this.cancelToken) {
      this.cancelToken(msg);
    }
  }
}
